"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Side = _interopRequireDefault(require("../Nav/Side"));

var _Top = _interopRequireDefault(require("../Nav/Top"));

var _HeaderComponent = _interopRequireDefault(require("../Header/HeaderComponent"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Layout = /*#__PURE__*/function (_Component) {
  _inherits(Layout, _Component);

  var _super = _createSuper(Layout);

  function Layout() {
    var _this;

    _classCallCheck(this, Layout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menuOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      _this.setState({
        menuOpen: !_this.state.menuOpen
      });
    });

    return _this;
  }

  _createClass(Layout, [{
    key: "render",
    value: function render() {
      var theme = this.props.theme,
          navBar = this.props.nav || this.props.navBar;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "\n          ".concat(theme.bg, " ").concat(theme.text, "\n          min-h-screen w-full flex flex-col\n        ")
      }, navBar === 'top' ? /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.fixed ? "fixed left-0 top-0 w-full z-10" : "w-full"
      }, /*#__PURE__*/_react["default"].createElement(_Top["default"], {
        logo: this.props.logo,
        open: this.state.menuOpen,
        toggle: this.toggleMenu,
        menuItems: this.props.menus,
        fixed: this.props.fixed,
        width: this.props.maxWidth
      })) : null, this.props.headerBar ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.fixed ? "fixed left-0 top-0 w-full z-10 ".concat(navBar === 'top' ? '' : '') : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.maxWidth, " mx-auto")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "\n                  fixed left-0 right-0 top-0\n                  ".concat(navBar === 'side' ? "md:ml-".concat(theme.sidebarW) : '', "\n                ")
      }, /*#__PURE__*/_react["default"].createElement(_HeaderComponent["default"], {
        navBar: navBar,
        title: (0, _lodash["default"])(this.props, ["headerBar", "title"], null)
      }, (0, _lodash["default"])(this.props, ["headerBar", "children"], []).map(function (child, i) {
        return typeof child === "function" ? /*#__PURE__*/_react["default"].createElement(child, {
          key: i
        }) : typeof child === "string" ? child : /*#__PURE__*/_react["default"].cloneElement(child, {
          key: i
        });
      }))))) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "\n          flex-1 flex items-stretch flex-col\n          ".concat(this.props.maxWidth ? this.props.maxWidth : 'w-full', "\n        ")
      }, navBar !== 'side' ? null : /*#__PURE__*/_react["default"].createElement(_Side["default"], {
        open: this.state.menuOpen,
        toggle: this.toggleMenu,
        menuItems: this.props.menus,
        fixed: this.props.fixed
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "\n                h-full flex-1 flex flex-col\n                ".concat(this.props.headerBar || navBar === "top" ? "mt-16" : '', "\n                ").concat(this.props.fixed && navBar === 'side' ? "md:ml-".concat(theme.sidebarW) : '', "\n              ")
      }, this.props.children)));
    }
  }]);

  return Layout;
}(_react.Component);

_defineProperty(Layout, "defaultProps", {
  fixed: false,
  maxWidth: '',
  headerBar: true,
  navBar: 'side',
  nav: null
});

var _default = Layout;
exports["default"] = _default;